var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        staticClass: "q-mt-md",
        attrs: {
          data: _vm.users_subscribed,
          columns: _vm.columns,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          "row-key": "id",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.request
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("div", { staticClass: "col" }),
                _c("q-btn", {
                  staticClass: "q-mr-sm",
                  attrs: {
                    color: "tertiary",
                    icon: "fas fa-file-download",
                    label: _vm.$t("download_guest_list"),
                    disable:
                      _vm.users_subscribed.length < 1 || !_vm.manageWebcasts
                  },
                  on: { click: _vm.downloadGuestList }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t(col.label)) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                {},
                [
                  _c("q-td", { key: "id", attrs: { props: props } }, [
                    _vm._v("\n\t\t\t\t\t" + _vm._s(props.row.id) + "\n\t\t\t\t")
                  ]),
                  _c("q-td", { key: "name", attrs: { props: props } }, [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(props.row.name) + "\n\t\t\t\t"
                    )
                  ]),
                  _c("q-td", { key: "email", attrs: { props: props } }, [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(props.row.email) + "\n\t\t\t\t"
                    )
                  ]),
                  _c("q-td", { key: "profile", attrs: { props: props } }, [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.translateProfiles(props.row.profile)) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              )
            }
          }
        ])
      }),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3" },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "fas fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_webcasts" })
                }
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }